import { render, staticRenderFns } from "./xePeekSetting.vue?vue&type=template&id=51831c54&scoped=true"
import script from "./xePeekSetting.vue?vue&type=script&lang=js"
export * from "./xePeekSetting.vue?vue&type=script&lang=js"
import style0 from "./xePeekSetting.vue?vue&type=style&index=0&id=51831c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51831c54",
  null
  
)

export default component.exports